import { storableError } from '../util/errors';
import * as log from '../util/log';
import {
  requestInvoicing as requestInvoicingApi,
  lookupInvoicingCompany as lookupInvoicingCompanyApi,
} from '../util/api';
import { fetchCurrentUser } from './user.duck';

// Requesting invoicing for the customer's company and looking the company up
// in Clevenio. Shared by the account page (BillingPage) and the transaction
// page (RequestInvoicingModal); the transaction refetch on approval is the
// transaction page's own concern.

// ================ Action types ================ //

export const REQUEST_INVOICING_REQUEST = 'app/invoicing/REQUEST_INVOICING_REQUEST';
export const REQUEST_INVOICING_SUCCESS = 'app/invoicing/REQUEST_INVOICING_SUCCESS';
export const REQUEST_INVOICING_ERROR = 'app/invoicing/REQUEST_INVOICING_ERROR';

export const LOOKUP_INVOICING_COMPANY_REQUEST = 'app/invoicing/LOOKUP_INVOICING_COMPANY_REQUEST';
export const LOOKUP_INVOICING_COMPANY_SUCCESS = 'app/invoicing/LOOKUP_INVOICING_COMPANY_SUCCESS';
export const LOOKUP_INVOICING_COMPANY_ERROR = 'app/invoicing/LOOKUP_INVOICING_COMPANY_ERROR';

export const CLEAR_INVOICING_REQUEST = 'app/invoicing/CLEAR_INVOICING_REQUEST';

// ================ Reducer ================ //

const initialState = {
  requestInvoicingInProgress: false,
  requestInvoicingError: null,
  requestInvoicingResult: null,
  lookupInvoicingCompanyInProgress: false,
  lookupInvoicingCompanyError: null,
  lookupInvoicingCompanyResult: null,
};

export default function invoicingReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case REQUEST_INVOICING_REQUEST:
      return { ...state, requestInvoicingInProgress: true, requestInvoicingError: null };
    case REQUEST_INVOICING_SUCCESS:
      return { ...state, requestInvoicingInProgress: false, requestInvoicingResult: payload };
    case REQUEST_INVOICING_ERROR:
      return { ...state, requestInvoicingInProgress: false, requestInvoicingError: payload };
    case LOOKUP_INVOICING_COMPANY_REQUEST:
      return {
        ...state,
        lookupInvoicingCompanyInProgress: true,
        lookupInvoicingCompanyError: null,
        lookupInvoicingCompanyResult: null,
      };
    case LOOKUP_INVOICING_COMPANY_SUCCESS:
      return {
        ...state,
        lookupInvoicingCompanyInProgress: false,
        lookupInvoicingCompanyResult: payload,
      };
    case LOOKUP_INVOICING_COMPANY_ERROR:
      return {
        ...state,
        lookupInvoicingCompanyInProgress: false,
        lookupInvoicingCompanyError: payload,
      };
    case CLEAR_INVOICING_REQUEST:
      return initialState;
    default:
      return state;
  }
}

// ================ Action creators ================ //

const requestInvoicingRequest = () => ({ type: REQUEST_INVOICING_REQUEST });
const requestInvoicingSuccess = result => ({ type: REQUEST_INVOICING_SUCCESS, payload: result });
const requestInvoicingError = e => ({ type: REQUEST_INVOICING_ERROR, error: true, payload: e });

const lookupInvoicingCompanyRequest = () => ({ type: LOOKUP_INVOICING_COMPANY_REQUEST });
const lookupInvoicingCompanySuccess = result => ({
  type: LOOKUP_INVOICING_COMPANY_SUCCESS,
  payload: result,
});
const lookupInvoicingCompanyError = e => ({
  type: LOOKUP_INVOICING_COMPANY_ERROR,
  error: true,
  payload: e,
});

export const clearInvoicingRequest = () => ({ type: CLEAR_INVOICING_REQUEST });

// ================ Thunks ================ //

export const requestInvoicing = payload => dispatch => {
  dispatch(requestInvoicingRequest());
  return requestInvoicingApi(payload)
    .then(result => {
      dispatch(requestInvoicingSuccess(result));
      dispatch(fetchCurrentUser());
      return result;
    })
    .catch(e => {
      dispatch(requestInvoicingError(storableError(e)));
      log.error(e, 'request-invoicing-failed', { country: payload && payload.country });
      throw e;
    });
};

export const lookupInvoicingCompany = ({ country, businessId }) => dispatch => {
  dispatch(lookupInvoicingCompanyRequest());
  return lookupInvoicingCompanyApi({ country, businessId })
    .then(result => {
      dispatch(lookupInvoicingCompanySuccess(result));
      return result;
    })
    .catch(e => {
      dispatch(lookupInvoicingCompanyError(storableError(e)));
      throw e;
    });
};
